import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { ErrorNotification } from 'SRC/ui/ErrorNotification'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'
import { getFormatDate } from 'SRC/modules/ads/list/functions/functions'
import { Refresh, TogglePause, MarkSold } from 'SRC/modules/ads/list/components/My/Buttons'
import { getButtonsStatusByAdsStatus } from 'SRC/modules/ads/list/components/My/Item/Item'
import { setProfileAdsError } from 'SRC/modules/users/Profile/actions'
import { getProfileAdsError } from 'SRC/modules/users/Profile/selectors'
import { adsStatues } from 'SRC/modules/ads/shared/constants'
import { getCurrentAd } from '../../selectors'

const refreshPeriodInHours = 48

export const EditAdButtons = ({ ad, setProfileAdsError, error }) => {
	const { t } = useTranslation('common')

	if (!ad) return null

	const { seo, status, listingStatus, listingActivated, listing, refreshed } = ad

	const getPayedToDate = () => {
		const listingDuration = listing === 2 ? 5 : listing === 3 ? 10 : 0

		if (listingActivated && listing && listingDuration) {
			let listingActivatedDate = new Date(listingActivated)
			listingActivatedDate.setDate(listingActivatedDate.getDate() + listingDuration)

			return listingActivatedDate
		}

		return null
	}

	const getRefreshedDateTime = () => {
		const refreshedDate = new Date(refreshed)
		refreshedDate.setHours(refreshedDate.getHours() + refreshPeriodInHours)
		return refreshedDate
	}

	const getPromoEndDate = () => {
		const payedTo = getPayedToDate()

		if (payedTo) return getFormatDate(payedTo)

		return ''
	}

	const payedToDate = getPayedToDate()
	const refreshedDateTime = getRefreshedDateTime()

	const isPaid = listingStatus === 'Active' && (new Date(payedToDate) > new Date())

	const hideError = () => {
		setProfileAdsError('')
	}

	const buttonsStatuses = getButtonsStatusByAdsStatus(status)

	return (
		<div className='oglasi-edit-buttons'>
			{['Published', 'Unpublished', 'Paused'].includes(status) ?
				listingStatus === 'Active' ? (
					<a className='oglasi-edit-button-promovisan' href='javascript:void(0)' style={{ cursor: 'default' }}>
						{t('PLAĆEN do')} {getPromoEndDate()}
					</a>
				) : (
					<Link href={`/activatePromo?ad=${seo}`} as={`/profil/oglasi/promo/${seo}`}>
						<a className='oglasi-edit-button-promovisi'>
							<i className='ico-promovisi-oglas ico' /> {t('Promoviši')} {t('oglas')}
						</a>
					</Link>
				) : null}

			{['Published', 'Unpublished', 'Paused'].includes(status) ? (
				<div className='moji-oglasi-item-content-akcije' style={{ gap: 5, marginTop: 5, flexWrap: 'nowrap' }}>
					<div className='moji-oglasi-akcije-item moji-oglasi-akcije-item__details'>
						<Link href={{ pathname: '/editAd', query: { ad: seo } }} as={`/profil/oglasi/izmeni/${seo}`}>
							<a>
								<i className='ico-izmijeni-oglas ico' />
								{t('Izmijeni')}
							</a>
						</Link>
					</div>

					<Refresh adId={ad.id} isAvailable={buttonsStatuses.refresh && (refreshedDateTime && refreshedDateTime <= new Date())} className='moji-oglasi-akcije-item moji-oglasi-akcije-item__details' />

					<TogglePause adId={ad.id} isAvailable={buttonsStatuses.togglePause} isPaused={status === adsStatues.PAUSED.code} className='moji-oglasi-akcije-item moji-oglasi-akcije-item__details' />

					<MarkSold adId={ad.id} isAvailable={buttonsStatuses.markSold} isPaid={isPaid} className='moji-oglasi-akcije-item moji-oglasi-akcije-item__details' />

				</div>
			) : null}

			<ErrorNotification hideNotification={hideError} error={error} />
		</div>
	)
}

EditAdButtons.propTypes = {
	ad: PropTypes.shape({
		id: PropTypes.number,
		seo: PropTypes.string,
		status: PropTypes.string,
		listing: PropTypes.number,
		listingStatus: PropTypes.string,
		listingActivated: PropTypes.string,
		refreshed: PropTypes.string
	}),
	error: PropTypes.string,
	setProfileAdsError: PropTypes.func.isRequired
}

const mapStateToProps = state => {
	return {
		ad: getCurrentAd(state),
		error: getProfileAdsError(state)
	}
}

export default connect(mapStateToProps, { setProfileAdsError })(EditAdButtons)
